import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useClient } from 'jsonapi-react';
import { FiChevronLeft } from 'react-icons/fi';
import { WidgetKpi, WidgetWrapper, WidgetKpiValue } from '@/components/custom/widget';
import ActivityDataPieChart from './ActivityDataPieChart';
import ActivityDataColumnChart from './ActivityDataColumnChart';
import { Loader } from '@/components/custom/loader';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function GeneralData(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { activity } = props;
  const client = useClient();
  const [isLoading, setIsLoading] = useState(true);
  const [activityReport, setActivityReport] = useState();
  const [status, setStatus] = useState('');
  const [statusClass, setStatusClass] = useState('');

  useEffect(() => {
    updateActivityStatus();
    getActivityReport();
  }, [activity]);

  const getActivityReport = async () => {
    setIsLoading(true);
    const { data } = await client.fetch(['activities', activity.id, 'activities_report?general=true']);
    setActivityReport(data);
    setIsLoading(false);
  };

  const updateActivityStatus = () => {
    let newStatus = t('textsCommon.available');
    let newStatusClass = 'activity-card__status--success';

    if (moment(activity['publish-at']) > moment()) {
      newStatus = t('textsCommon.unavailable');
      newStatusClass = 'activity-card__status--warning';
    }

    // else if (moment(activity['finish-at']) < moment()) {
    //   newStatus = 'Expirado';
    //   newStatusClass = 'activity-card__status--danger';
    // }

    setStatus(newStatus);
    setStatusClass(newStatusClass);
  };

  return (
    <div className="animate-fade-in">
      <div
        className="filter-bar"
        style={{ alignItems: 'center' }}
      >
        <button
          onClick={() => navigate(-1)}
          className="filter-bar__back"
        >
          <span className="card__icon-wrapper">
            <FiChevronLeft className="card__icon" />
          </span>

          <span className="filter-bar__back-container">
            <span className="filter-bar__title">{t('textsCommon.data')}</span>
          </span>
        </button>

        <span className="filter-bar__box u-ml-auto">
          {t('textsCommon.lastUpdateAt')} {activityReport?.lastUpdate && moment(activityReport.lastUpdate).format('DD/MM/YYYY H:mm')}h
        </span>
      </div>

      <div className="chart-widget mb-4">
        <div className="chart-widget__container">
          <div className="chart-widget__group">
            <div className="chart-widget__meta">
              <span className={`activity-card__status u-mr-2 ${statusClass}`}>{status}</span>
              {/* <span className="activity-card__available">
                {t('textsCommon.until')} {moment(activity['finish-at']).format(t('datesForm.formatDate'))}
              </span> */}
            </div>

            <h3 className="chart-widget__title chart-widget__title--lg">{activity.title}</h3>
          </div>
          <WidgetWrapper space="sm">
            <WidgetKpi
              title={t('textsCommon.submissionIndex')}
              variant="light"
            >
              <WidgetKpiValue>{(activityReport?.percentActivitySend && Math.round(activityReport?.percentActivitySend)) || 0}%</WidgetKpiValue>
            </WidgetKpi>

            <WidgetKpi
              title={t('textsCommon.totalStudents')}
              variant="light"
            >
              <WidgetKpiValue>{activityReport?.studentsPerCourse || 0}</WidgetKpiValue>
            </WidgetKpi>
          </WidgetWrapper>
        </div>
      </div>

      <div className="chart-widget-wrapper">
        <div className="chart-widget">
          <div className="chart-widget__header">
            <h3 className="chart-widget__title">{t('activity.totalSubmissions')}</h3>
          </div>
          <div className="chart-widget__body">{isLoading ? <Loader /> : <ActivityDataPieChart activityReport={activityReport} />}</div>
        </div>

        <div className="chart-widget">
          <div className="chart-widget__header">
            <h3 className="chart-widget__title">{t('activity.comparisonTitleCourses')}</h3>
          </div>
          <div className="chart-widget__body">{isLoading ? <Loader /> : <ActivityDataColumnChart activityReport={activityReport} />}</div>
        </div>
      </div>
    </div>
  );
}
